var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAge10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#0095DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.93313 17V8.28L3.94913 8.808V7.08L6.86113 5.8H8.17313V17H5.93313ZM14.9133 17.192C13.8999 17.192 13.0253 16.9467 12.2893 16.456C11.5533 15.9653 10.9879 15.288 10.5933 14.424C10.2093 13.5493 10.0173 12.5413 10.0173 11.4C10.0173 10.2587 10.2093 9.256 10.5933 8.392C10.9879 7.51733 11.5479 6.83467 12.2733 6.344C13.0093 5.85333 13.8893 5.608 14.9133 5.608C15.9373 5.608 16.8119 5.85333 17.5373 6.344C18.2733 6.83467 18.8333 7.51733 19.2173 8.392C19.6119 9.256 19.8093 10.2587 19.8093 11.4C19.8093 12.5413 19.6119 13.5493 19.2173 14.424C18.8333 15.288 18.2733 15.9653 17.5373 16.456C16.8119 16.9467 15.9373 17.192 14.9133 17.192ZM14.9133 15.256C15.4466 15.256 15.9159 15.1013 16.3213 14.792C16.7266 14.472 17.0413 14.024 17.2653 13.448C17.4999 12.872 17.6173 12.1893 17.6173 11.4C17.6173 10.6 17.4999 9.91733 17.2653 9.352C17.0413 8.776 16.7266 8.33333 16.3213 8.024C15.9159 7.71467 15.4466 7.56 14.9133 7.56C14.3799 7.56 13.9106 7.71467 13.5052 8.024C13.0999 8.33333 12.7799 8.776 12.5453 9.352C12.3213 9.91733 12.2093 10.6 12.2093 11.4C12.2093 12.1893 12.3213 12.872 12.5453 13.448C12.7799 14.024 13.0999 14.472 13.5052 14.792C13.9106 15.1013 14.3799 15.256 14.9133 15.256Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAge10);
export default __webpack_public_path__ + "static/media/age-10.e70e11d98366ae5b21dfbf95d4538e09.svg";
export { ForwardRef as ReactComponent };